import React, { Component } from 'react';
import {Link} from 'react-router-dom'
class TopBar extends Component {
    render() {
        return (
            <div className="top border-bt-d1d1ff style2">
                <div className="overlay" />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12">
                            <div className="flat-info">
                                <ul>
                                <li className="phone"><Link to="#">+123 345 678 000</Link></li>
                                <li className="mail"><Link to="#">info@example.com</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12 pd-left-0">
                            <div className="flat-adds flat-text-right">
                                <p>Enjoy A New Student Discount All <span className="font-Roboto font-weight-700 underline-text">55,000 Courses</span> on sale for <span className="font-Hall font-weight-700 letter-spaceing-top">Only </span> <span className="font-Playfair font-weight-700 letter-spaceing-top">$12.99 </span> </p><p className="font-weight-700 datetime">Ends in 05h 23m 49s </p>
                            </div>
                            <div className="flat-action flat-text-right style1">
                                <ul>
                                <li><Link to="#">REGISTER</Link></li>
                                <li><Link to="#">LOGIN</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        );
    }
}

export default TopBar;